<template>
  <div class="web-box-all">
    <ext-header select_menu="4"></ext-header>

    <div class="web-home-main">
      <div class="web-home-title">
        <a></a>
        <p>{{title}}<i></i></p>
        <a></a>
      </div>
    </div>

    <div class="web-goods-main">
      <div class="web-home-goods">

        <div v-for="(vo,index) in list_data" :key="index" :class="[vo.select==1 ? 'web-home-goods-list active' : 'web-home-goods-list']" v-on:mouseover="changeActive(index,'list_data')" v-on:mouseout="removeActive(index,'list_data')">
          <div @click="get_goods_show(vo.goods_no)" :class="[vo.select==1 ? 'web-home-goods-list-data active' : 'web-home-goods-list-data']">
            <img src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
            <h2>{{vo.goods_name}}</h2>
            <h3>{{vo.goods_no}}</h3>
            <p>
              <i>¥</i><b>{{vo.goods_money}}</b>
            </p>
          </div>
          <h4>
            <b class="del" @click="goods_del(index)">-</b>
            <b class="num">
              <input type="number" v-model.number="vo.qty" oninput="if(value.length>3)value=value.slice(0,3)" />
            </b>
            <b class="add" @click="goods_add(index)">+</b>
            <b class="cart" @click="add_cart(index,vo.goods_no)">加入购物车</b>
          </h4>
        </div>

      </div>

      <div class="web-order-list-page">
        <b-pagination
          v-model="currentPage"
          :total-rows="list_count"
          :per-page="perPage"
          @change="load_page"
          first-number
          last-number
        >
        <template #prev-text><span class="lemon-page">上一页</span></template>
        <template #next-text><span class="lemon-page">下一页</span></template>
        <template #page="{ page, active }">
          <b class="lemon-page-now" v-if="active">{{ page }}</b>
          <i class="lemon-page-line" v-else>{{ page }}</i>
        </template>
        </b-pagination>
      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/home'
import ExtFooter from '@/components/footer/home'
import {getUserId, ajax, Encrypt, webUrl} from '@/utils/extend'
import Toast from '@/components/toast/index'

export default {
  name: 'new_activity_goods',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'ext-toast': Toast
  },
  data () {
    return {
      title: '积分兑换',
      web_url: webUrl(),
      select_menu: '',
      perPage: 10,
      currentPage: 1,
      list_data: [],
      list_count: 0,
      toast_state: 'display:none',
      toast_text: ''
    }
  },
  mounted () {
    this.load_data()
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    get_goods_show (goodsNo) {
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    goods_add (index) {
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1
      if (qty < 999) {
        qty = qty + 1
      } else {
        qty = 999
      }
      this.$set(this.list_data[index], 'qty', qty)
    },
    goods_del (index) {
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1
      if (qty > 1) {
        qty = qty - 1
      } else {
        qty = 1
      }
      this.$set(this.list_data[index], 'qty', qty)
    },
    add_cart (index, goodsNo) {
      var that = this
      var listdata = this.list_data
      var qty = listdata[index].qty ? listdata[index].qty : 1

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          type_id: 1,
          type_add: 'add',
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
        } else {
          that.toast(ret.msg)
        }
      })
    },
    changeActive (index, list) {
      this.$set(this['' + list][index], 'select', '1')
    },
    removeActive (index, list) {
      this.$set(this['' + list][index], 'select', '0')
    },
    load_page (page) {
      this.currentPage = page
      this.load_data()
    },
    load_data () {
      var that = this
      // that.list_data = []
      var page = that.currentPage
      ajax({
        url: '/store/goods/integral_goods_list',
        method: 'post',
        data: {
          uid: getUserId(),
          page: page
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var list = ret.data.list_data

          var LlistArray = []
          list.forEach(function (vo) {
            LlistArray.push({
              'id': vo.id,
              'goods_no': vo.goods_no,
              'sectionId': vo.sectionId,
              'goods_name': vo.goods_name,
              'goods_image': vo.goods_image,
              'goods_remark': vo.goods_remark,
              'goods_money': vo.goods_money,
              'integral': vo.integral,
              'goods_qty': vo.goods_qty,
              'qty': 1
            })
          })
          that.list_data = LlistArray
          that.list_count = ret.data.list_count
        } else {
          that.list_data = []
          that.list_count = 0
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1200px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
  .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
  .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
  .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
  .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:12px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

/* 商品列表 */
.web-goods-main { width:1225px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
  .web-home-goods-list { width:245px; height:410px; position: relative; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
  .web-home-goods-list.active { border:1px solid #d81e06;}
  .web-home-goods-list-data { width:223px; height:390px; cursor: pointer; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods-list-data.active { border:1px solid #ffffff;}
  .web-home-goods-list-data img { width:100%; height:230px; padding:10px 10px 0px 10px; object-fit: cover;}
  .web-home-goods-list-data h2 { width:223px; height:40px; line-height:20px; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data h3 { width:223px; height:20px; line-height:20px; margin:0px; font-size:12px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data p { width:223px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data p i { font-size:12px; margin-right:5px; font-style:normal; color:#d81e06;}
  .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}
  .web-home-goods-list h4 { width:213px; height:40px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; position: absolute; left:15px; bottom: 10px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list h4 b { font-size:14px; line-height:30px; float:left; font-weight: normal;}
  .web-home-goods-list h4 b.del { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num { width:44px; height:30px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.num input { width:44px; height:20px; margin-top:5px; text-align: center; line-height:20px; font-size:12px; color:#333333; min-height:20px; border:0px;}
  .web-home-goods-list h4 b.add { width:30px; height:30px; cursor: pointer; line-height:25px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-home-goods-list h4 b.cart { width:80px; height:30px; cursor: pointer; margin-left:8px; text-align: center; line-height:30px; background: #d81e06; font-size:13px; color:#ffffff;}

    .web-order-list-page { width:100%; height:40px; margin-top:20px;}

    .lemon-page { color:#333333; font-size:12px; height:24px; line-height:24px;}
    .lemon-page-now { background: #d81e06 !important; color:#ffffff !important; width:24px; height:24px;}
    .lemon-page-line { color:#333333; font-style: normal;}

</style>
<style>
  .page-item.active .page-link { border:1px solid #d81e06;background: #d81e06 !important; color:#ffffff !important;}
</style>



// WEBPACK FOOTER //
// src/pages/points/points_goods.vue